import getTranslation from '../translations';

function useTranslation(lang = "nl",reference, string) {
  const language = lang;
  const translatedString = getTranslation(language, reference) || string;
  return translatedString;
}

export default useTranslation;